// extracted by mini-css-extract-plugin
export default {"noticeContainer":"dJ8pO","newNotice":"+yD0o","noticeBody":"Bh8tK","infoGroup":"xi2QS","userNickname":"_13uUk","commentDate":"ZRFop","date":"_2DfZq","uppercase":"s3prs"};